import z from "zod";
import { availableChatProviders } from "../../../types/providers/chat-provider";

export const availableChatProvidersValidator = z.object({
    CHAT_PROVIDER: z.enum(availableChatProviders).default("azure"),
})
export type AvailableChatProvidersValidator = z.infer<typeof availableChatProvidersValidator>;


export const azureChatProviderValidator = z.object({
  AZURE_OPENAI_API_KEY: z.string().min(1, "required").optional(),
  AZURE_OPENAI_API_INSTANCE_NAME: z.string().min(1, "required").optional(),
  AZURE_OPENAI_API_VERSION: z.string().min(1, "required").optional(),
  AZURE_OPENAI_API_DEPLOYMENT_NAME: z.string().min(1, "required").optional(),
  AZURE_OPENAI_API_TEMPERATURE: z.number().min(0).max(2).optional(),
  AZURE_OPENAI_API_MAX_TOKENS: z.number().min(1).optional(),
});
export type AzureChatProviderValidator = z.infer<typeof azureChatProviderValidator>;


export const ollamaChatProviderValidator = z.object({
  OLLAMA_BASE_URL: z.string().url().optional(),
  OLLAMA_MODEL: z.string().min(1, "required").optional(),
  OLLAMA_TEMPERATURE: z.number().min(0).max(2).optional(),
  OLLAMA_MAX_TOKENS: z.number().min(1).optional(),
});
export type OllamaAIChatProviderValidator = z.infer<typeof ollamaChatProviderValidator>;


export const vllmChatProviderValidator = z.object({
  VLLM_BASE_URL: z.string().url().optional(),
  VLLM_MODEL: z.string().optional(),
  VLLM_TEMPERATURE: z.number().min(0).max(2).optional(),
  VLLM_MAX_TOKENS: z.number().min(1).optional(),
});
export type VLLMChatProviderValidator = z.infer<typeof vllmChatProviderValidator>;


export const junetChatProviderValidator = z.object({
  JUNET_BASE_URL: z.string().url().optional(),
  JUNET_API_KEY: z.string().optional(),
  JUNET_MODEL: z.string().min(1, "required").optional(),
  JUNET_TEMPERATURE: z.number().min(0).max(2).optional(),
  JUNET_MAX_TOKENS: z.number().min(1).optional(),
});
export type JunetChatProviderValidator = z.infer<typeof junetChatProviderValidator>;


export const openRouterChatProviderValidator = z.object({
  OPEN_ROUTER_API_KEY: z.string().min(1, "required").optional(),
  OPEN_ROUTER_MODEL: z.string().min(1, "required").optional()
})
export type OpenRouterChatProviderValidator = z.infer<typeof openRouterChatProviderValidator>;


export const openAIChatProviderValidator = z.object({
  OPENAI_API_KEY: z.string().min(1, "required").optional(),
  OPENAI_MODEL: z.string().min(1, "required").optional(),
  OPENAI_BASE_URL: z.string().url().optional(),
  OPENAI_TEMPERATURE: z.number().min(0).max(2).optional(),
  OPENAI_MAX_TOKENS: z.number().min(1).optional(),
});
export type OpenAIChatProviderValidator = z.infer<typeof openAIChatProviderValidator>;


export const anthropicChatProviderValidator = z.object({
  ANTHROPIC_API_KEY: z.string().min(1, "required").optional(),
  ANTHROPIC_MODEL: z.string().min(1, "required").optional(),
  ANTHROPIC_BASE_URL: z.string().url().optional(),
  ANTHROPIC_TEMPERATURE: z.number().min(0).max(1).optional(),
  ANTHROPIC_MAX_TOKENS: z.number().min(1).optional(),
});
export type AnthropicChatProviderValidator = z.infer<typeof anthropicChatProviderValidator>;


export const chatProviderConfigSchemas = {
  azure: azureChatProviderValidator,
  ollama: ollamaChatProviderValidator,
  vllm: vllmChatProviderValidator,
  junet: junetChatProviderValidator,
  openrouter: openRouterChatProviderValidator,
  openai: openAIChatProviderValidator,
  anthropic: anthropicChatProviderValidator,
} as const;